import "./AddCreditCardModal.scss"
import { FC, useRef, useState, useEffect, SyntheticEvent } from "react"
import GenericModal from "../GenericAppModal/GenericModal.component"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { showAlert } from "../../../redux/slices/alertSlice"
import {
  getCCIFrameURLAsync,
  getUserAsync,
} from "../../../redux/slices/authSlice"
import { isValidUrl } from "../../../utils/utils"
import { useIsMobile } from "../../../hooks/useIsMobile"

type AddCreditCardModalProps = {
  open: boolean
  handleClose: () => void
}

const AddCreditCardModal: FC<AddCreditCardModalProps> = ({
  open,
  handleClose,
}) => {
  const { ADD_CARD_MODAL_TITLE, REQ_SUCCESS } = useTranslationLabel()
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.auth.userData)
  const [loading, setLoading] = useState(false)
  const [iframeUrl, setIframeUrl] = useState<string | null>(null)
  const iframeRef = useRef(null)
  const isMobile = useIsMobile()

  const onMyFrameLoad = async (
    event: SyntheticEvent<HTMLIFrameElement, Event>,
  ) => {
    try {
      if (iframeRef.current) {
        const iframe = iframeRef.current as HTMLIFrameElement
        const newUrl = iframe.contentWindow?.location.href
        if (newUrl?.includes("success") && newUrl?.includes("Token") && user) {
          await dispatch(getUserAsync())
          dispatch(
            showAlert({
              text: REQ_SUCCESS,
              type: "success",
            }),
          )
          handleClose()
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    async function fetchData() {
      if (user !== null) {
        const resIframeURL = await dispatch(getCCIFrameURLAsync(user))
        const data = resIframeURL.payload
        setIframeUrl(data?.url)
      }
      setLoading(false)
    }
    fetchData()
  }, [user])

  useEffect(() => {
    setLoading(true)
  }, [])

  return (
    <GenericModal
      title={ADD_CARD_MODAL_TITLE}
      className="add-credit-card-modal"
      open={open}
      loading={loading}
      handleClose={handleClose}
    >
      {isValidUrl(iframeUrl) ? (
        <iframe
          style={{
            width: isMobile ? "100%" : 420,
            height: 650,
            border: "none",
          }}
          id="rivhitIframe"
          title="rivhitIframe"
          src={(iframeUrl as string | null) || ""}
          onLoad={(e) => {
            onMyFrameLoad(e)
          }}
          ref={iframeRef}
          //@ts-ignore
          allowpaymentrequest={"true"}
        />
      ) : null}
    </GenericModal>
  )
}

export default AddCreditCardModal
